import { combineReducers } from "redux";
import { requestLoginReducer, fetchLoginReducer } from "./login-reducers";
import {
  fetchWaitReducer,
  fetchGeneralReducer,
  fetchToastNotifyReducer,
  fetchProfileReducer,
} from "./app-reducer";

const rootReducer = combineReducers({
  // app-reducer
  General: fetchGeneralReducer,
  Wait: fetchWaitReducer,
  ToastNotify: fetchToastNotifyReducer,
  Profile: fetchProfileReducer,
  // screen-reducer
  LoginReq: requestLoginReducer, // login request
  LoginRes: fetchLoginReducer, // login response--
});

export default rootReducer;
